import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';       // must be imported before App so translations are ready
import './index.css';
import App from './App';

// Register service worker early so media caching (MP3 / images / PDFs) is
// active even for students who haven't granted notification permission.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js').catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);